export default __webpack_public_path__ + "static/media/Router_3.c41bd066.svg";